<template>
  <ClaimsListComp></ClaimsListComp>
</template>
<script>
import ClaimsListComp from "../../components/Claim/ClaimList.vue";

export default {
  name: "Claims List",
  components: { ClaimsListComp },
  computed: {},
  mounted() {},
};
</script>
